module.exports = __webpack_public_path__ + "assets/warning.a453b237ce704655704b1d6546e4ce0f.svg";